const initializeCollectionDescriptions = root => {
  root.querySelectorAll('[data-onnuto-collection-description]').forEach(container => {
    if (container.dataset.onnutoInitialized === 'true') return;

    const preview = container.querySelector('.onnuto-collection-description__preview');
    const toggle = container.querySelector('.onnuto-collection-description__toggle');
    if (!preview || !toggle) return;

    container.dataset.onnutoInitialized = 'true';
    const updateToggleVisibility = () => {
      if (container.classList.contains('is-expanded')) return;
      toggle.hidden = preview.scrollHeight <= preview.clientHeight + 1;
    };

    toggle.addEventListener('click', () => {
      const expanded = container.classList.toggle('is-expanded');
      toggle.setAttribute('aria-expanded', String(expanded));
      toggle.setAttribute('aria-label', expanded ? toggle.dataset.lessLabel : toggle.dataset.moreLabel);
    });

    requestAnimationFrame(updateToggleVisibility);
    if ('ResizeObserver' in window) {
      new ResizeObserver(updateToggleVisibility).observe(preview);
    }
  });
};

initializeCollectionDescriptions(document);
document.addEventListener('shopify:section:load', event => initializeCollectionDescriptions(event.target));
